import {  html, LitElement } from "lit";
import { customElement, property } from "lit/decorators";
import { ifDefined } from 'lit/directives/if-defined.js';
import {
  containerStyles, moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';

@customElement("webs-form")
export class Form extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    typographyStyles,

  ];

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  @property()
  position: string;

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}" class="m-form ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="container">
          <webs-grid-row justify="${this.position == 'center' ? 'center' : this.position == 'right' ? 'flex-end' : 'flex-start'}">
            <webs-grid-column md="6">
              <slot name="title"></slot>
              <slot></slot>
            </webs-grid-column>
          </webs-grid-row>
        </div>
      </section>
    `;
  }
}
